'use strict';

var Sugar = require('sugar-core');

require('./build/buildDateUnitMethodsCall');

module.exports = Sugar.Date.hoursAgo;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/date/hoursAgo.js
// module id = 192
// module chunks = 1